import {Component, Input, OnInit} from '@angular/core';
import {OnlineVorhersageBericht, OzonBericht} from '../../../../../../../model/vorhersagen/radiobremen-wetterbericht';

@Component({
  selector: 'app-radiobremen-ozon-bericht',
  templateUrl: './radiobremen-ozon-bericht.component.html',
  styleUrls: ['../../wetterbericht.component.css']
})
export class RadiobremenOzonBerichtComponent {
  @Input() ozonBericht: OzonBericht;


}
